{
  "nav": {
    "tauler": "Centre de control",
    "activacions": "Activacions",
    "seguiment": "Seguiment en directe",
    "novaActivacio": "Nova activació"
  },
  "titols": {
    "tauler": "Centre de control",
    "activacions": "Activacions",
    "detall": "Detall de l'activació",
    "seguiment": "Seguiment en directe",
    "novaActivacio": "Nova activació"
  },
  "confirmacions": "{{confirmats}}/{{total}}",
  "columnes": {
    "activacio": "Activació",
    "codi": "Codi",
    "tipus": "Tipus",
    "titol": "Títol",
    "area": "Àrea",
    "servei": "Servei",
    "zona": "Zona",
    "tecnic": "Tècnic de guàrdia",
    "usuaris": "Usuaris a informar",
    "confirmacions": "Confirmacions",
    "estat": "Estat",
    "obert": "Obert"
  },
  "tauler": {
    "kpi": {
      "obertes": "Obertes",
      "obertesDetall": "{{it}} Guàrdia · {{crisi}} Crisi",
      "crisi": "En àrees de crisi",
      "resposta": "Resposta mitjana",
      "respostaDetall": "Fins a la primera confirmació",
      "confirmacions": "Confirmacions",
      "confirmacionsDetall": "{{confirmats}} de {{total}} destinataris",
      "guardia": "Àrees amb guàrdia",
      "guardiaDetall_one": "de {{count}} àrea",
      "guardiaDetall_other": "de {{count}} àrees",
      "tancades": "Tancades (mes)",
      "tancadesDetall": "Resoltes, mitigades o finalitzades",
      "crisiDetall_one": "{{count}} àrea de crisi activa",
      "crisiDetall_other": "{{count}} àrees de crisi actives"
    },
    "obertes": "Activacions obertes",
    "veureTotes": "Veure-les totes",
    "senseObertes": "No hi ha cap activació oberta.",
    "perDia": "Activacions per dia (últims {{dies}} dies)",
    "confirmacionsDirecte": "Confirmacions en directe",
    "confirmatsDe": "{{confirmats}} de {{total}} destinataris confirmats",
    "tecnicsArea": "Tècnics de guàrdia per àrea",
    "senseTecnic": "Sense tècnic de guàrdia",
    "ambdues": "Guàrdia i Crisi",
    "senseArees": "No hi ha àrees amb calendari de guàrdia.",
    "substitut": "subst. {{nom}}"
  },
  "llista": {
    "tipusArea": "Tipus d'àrea",
    "totesArees": "Totes les àrees",
    "periode": "Període",
    "periodes": {
      "7": "Últims 7 dies",
      "30": "Últims 30 dies",
      "90": "Últims 90 dies",
      "tots": "Tot l'historial"
    },
    "totsTipus": "Tots els tipus",
    "totsServeis": "Tots els serveis",
    "totesZones": "Totes les zones",
    "totsEstats": "Tots els estats",
    "persona": "Només les meves",
    "cerca": "Codi, títol o servei",
    "buida": "No hi ha activacions amb aquests filtres.",
    "exporta": "Exporta",
    "mostrant_one": "Mostrant {{count}} de {{total}} activacions",
    "mostrant_other": "Mostrant {{count}} de {{total}} activacions",
    "pagina": "Pàgina {{page}} de {{total}}",
    "anterior": "Anterior",
    "seguent": "Següent",
    "chip": {
      "tots": "Tots",
      "totes": "Totes",
      "tipus": "Tipus: {{valor}}",
      "area": "Àrea: {{valor}}",
      "servei": "Servei: {{valor}}",
      "zona": "Zona: {{valor}}",
      "estat": "Estat: {{valor}}",
      "obertes": "Obertes",
      "obertesN": "Obertes · {{count}}",
      "meves": "Meves",
      "tancades": "Tancades",
      "filtres": "Filtres",
      "filtresN": "Filtres · {{count}}"
    },
    "nova": "Nova",
    "cercaEtiqueta": "Cerca activacions",
    "filtresRapids": "Filtres ràpids",
    "capTriada": "Cap activació seleccionada",
    "capTriadaText": "Tria’n una de la llista per veure’n el detall."
  },
  "detall": {
    "tornaLlista": "Torna a la llista",
    "nivell": "Nivell {{nivell}}",
    "espera": "Espera {{temps}}",
    "versio": "v{{versio}}",
    "panells": {
      "dades": "Dades de l'activació",
      "cronologia": "Cronologia",
      "conversa": "Conversa",
      "destinataris": "Destinataris",
      "escalat": "Cadena d'escalat",
      "documentacio": "Documentació del servei"
    },
    "camps": {
      "codi": "ID",
      "tipus": "Tipus",
      "departament": "Departament",
      "area": "Àrea",
      "servei": "Servei",
      "zona": "Zona / ubicació",
      "activador": "Persona activadora",
      "contacte": "Persona de contacte",
      "inici": "Inici de l'incident",
      "obert": "Data d'obertura",
      "primeraConfirmacio": "Primera confirmació",
      "canals": "Canals",
      "descripcio": "Descripció",
      "proves": "Proves realitzades",
      "risc": "Risc",
      "perills": "Perills identificats",
      "mesures": "Mesures d'actuació",
      "itcau": "Incidència ITCAU",
      "motiuTancament": "Motiu de tancament",
      "tancada": "Data de tancament",
      "comentari": "Comentari",
      "nota": "Nota",
      "motiu": "Motiu",
      "itcauRef": "Referència ITCAU",
      "itcauUrl": "Enllaç (opcional)",
      "missatgeFinal": "Missatge de finalització",
      "mesuresPendents": "Mesures pendents",
      "notificar": "Notifica el tancament als destinataris",
      "format": "Format",
      "titol": "Títol",
      "estat": "Estat",
      "confirmats": "Confirmats",
      "pendents": "Pendents"
    },
    "accions": {
      "afegeixNota": "Afegeix nota",
      "activaExpert": "Activa expert",
      "escalaAra": "Escala ara",
      "escala": "Escala",
      "vinculaItcau": "Vincula ITCAU",
      "informe": "Informe",
      "tanca": "Tanca l'activació",
      "descarrega": "Descarrega",
      "obre": "Obre",
      "reenvia_one": "Reenvia a {{count}} pendent",
      "reenvia_other": "Reenvia a {{count}} pendents",
      "tancaCurt": "Tanca",
      "confirma": "Confirma la recepció",
      "accepta": "Accepta la gestió",
      "afegeixDestinataris": "Afegeix destinataris",
      "afegeixN_one": "Afegeix {{count}} persona",
      "afegeixN_other": "Afegeix {{count}} persones",
      "mes": "Més accions"
    },
    "modals": {
      "nota": "Afegeix una nota",
      "escalar": "Escala l'activació",
      "itcau": "Vincula amb ITCAU",
      "expert": "Activa el tècnic expert",
      "tancar": "Tanca l'activació",
      "informe": "Informe de l'activació",
      "destinataris": "Afegeix destinataris"
    },
    "escalarText": "S'avisarà els destinataris del nivell {{nivell}} del circuit d'escalat.",
    "escalarTria": "Tria a qui vols escalar. Primer es mostren els tècnics experts del servei.",
    "escalarExperts": "Tècnics experts",
    "escalarAltres": "Altres persones",
    "escalarCerca": "Cerca una persona…",
    "escalarSenseCandidats": "No s'ha trobat cap persona.",
    "escalarA": "Escala a {{nom}}",
    "escalarCircuit": "Escala al nivell següent del circuit",
    "itcauText": "El vincle és manual: no se sincronitza cap camp amb ITCAU.",
    "expertText": "S'avisarà el tècnic expert titular del servei {{servei}} (o el substitut si no està disponible).",
    "informeText": "Inclou destinataris, canals, marques de temps, confirmacions, missatges i accions.",
    "missatgeFinalPlaceholder": "SITUACIÓ FINALITZADA. Es recupera la normalitat.",
    "reenviarText": "Reenvia l'avís a les persones pendents des d'aquí.",
    "reenviat_one": "S'ha reenviat {{count}} avís.",
    "reenviat_other": "S'han reenviat {{count}} avisos.",
    "senseAccions": "Encara no hi ha cap acció registrada.",
    "senseMissatges": "Encara no hi ha missatges.",
    "senseDestinataris": "No hi ha destinataris.",
    "senseDocuments": "El servei no té documentació publicada.",
    "escriuMissatge": "Escriu una actualització… (@ per mencionar)",
    "mencions": "Mencions",
    "tipusMencio": {
      "USUARI": "Persona",
      "SERVEI": "Servei",
      "DEPARTAMENT": "Departament"
    },
    "tipusMissatge": {
      "TEXT": "Missatge",
      "RISC": "Risc",
      "AFECTACIO": "Afectació",
      "NOVETAT": "Novetat",
      "RECURSOS": "Recursos",
      "SISTEMA": "Sistema",
      "FINALITZACIO": "Finalització"
    },
    "accio": {
      "CREADA": "{{usuari}} ha creat l'activació",
      "ENVIADA": "Avís enviat als destinataris",
      "CONFIRMADA": "{{usuari}} ha confirmat la recepció",
      "ACCEPTADA": "{{usuari}} ha acceptat l'activació",
      "REENVIADA": "{{usuari}} ha reenviat l'avís als pendents",
      "ESCALADA": "Escalat al següent nivell",
      "escaladaNivells": "Escalada del nivell {{origen}} al {{desti}}",
      "per": "per {{usuari}}",
      "automatic": "automàticament",
      "EXPERT_ACTIVAT": "{{usuari}} ha activat el tècnic expert",
      "NOTA": "{{usuari}} ha afegit una nota",
      "ITCAU_VINCULAT": "{{usuari}} ha vinculat la incidència ITCAU",
      "TANCADA": "{{usuari}} ha tancat l'activació",
      "DOCUMENT_CONSULTAT": "{{usuari}} ha consultat un document",
      "ALTRA": "Acció registrada per {{usuari}}"
    },
    "tipusDesti": {
      "TECNIC_GUARDIA_TITULAR": "Tècnic de guàrdia titular",
      "TECNIC_GUARDIA_SUBSTITUT": "Tècnic de guàrdia substitut",
      "TECNIC_GUARDIA_DEPARTAMENT": "Tècnic de guàrdia del departament",
      "TECNIC_GUARDIA_ALTRES_AREES": "Tècnics de guàrdia d'altres àrees",
      "EXPERT_TITULAR": "Tècnic expert titular",
      "EXPERT_SUBSTITUT": "Tècnic expert substitut",
      "USUARI": "Persona",
      "GRUP": "Grup",
      "ALTRE": "Destinataris del nivell"
    },
    "estatNivell": {
      "fet": "Avisat",
      "actual": "Nivell actual",
      "pendent": "Pendent"
    },
    "tu": "Tu",
    "haAcceptat": "ha acceptat la gestió",
    "deTotal": "{{valor}} de {{total}}",
    "nivellMinuts": "Nivell {{nivell}} · {{minuts}} min",
    "senseCircuit": "El servei no té cap circuit d'escalat configurat.",
    "documentsNota": "Només consulta per a rols autoritzats del servei {{servei}}.",
    "propi": {
      "titol": "Ets destinatari d'aquesta activació",
      "textConfirmar": "Confirma que l'has rebuda perquè no s'escali al nivell següent.",
      "textAcceptar": "Com a tècnic, pots assumir-ne la gestió."
    },
    "destinatarisText": "Les persones afegides reben l'avís pels canals de l'activació i entren al bloc de destinataris addicionals.",
    "cercaPersona": "Cerca per nom o correu…",
    "treu": "Treu {{nom}}",
    "senseResultats": "Cap persona coincideix amb la cerca.",
    "expertTria": "Tècnic expert a activar",
    "expertAutomatic": "Automàtic",
    "expertAutomaticText": "El titular disponible o, si no, el substitut",
    "rolExpert": {
      "TITULAR": "Titular",
      "SUBSTITUT": "Substitut"
    },
    "accioTitol": {
      "CREADA": "Activació creada",
      "ENVIADA": "Notificació enviada",
      "CONFIRMADA": "Confirmació",
      "ACCEPTADA": "Gestió acceptada",
      "REENVIADA": "Avís reenviat",
      "ESCALADA": "Escalada",
      "EXPERT_ACTIVAT": "Expert activat",
      "NOTA": "Nota",
      "ITCAU_VINCULAT": "Vinculada a ITCAU",
      "TANCADA": "Activació tancada",
      "DOCUMENT_CONSULTAT": "Document consultat",
      "ALTRA": "Acció"
    },
    "obertaPer": "oberta {{hora}} per {{persona}}",
    "itcauRef": "ITCAU {{ref}}",
    "itcauSense": "ITCAU sense vincular",
    "senseActivitat": "Encara no hi ha activitat registrada.",
    "pestanyes": {
      "etiqueta": "Seccions del detall",
      "activitat": "Activitat",
      "xat": "Xat · {{count}}",
      "persones": "Persones · {{count}}",
      "dades": "Dades",
      "documents": "Documents · {{count}}"
    },
    "franja": {
      "confirmats": "Confirmats",
      "haConfirmat": "ha confirmat a les {{hora}}",
      "escalat": "Escalat",
      "nivellSeguent": "Nivell {{actual}} → nivell {{seguent}} ({{desti}})",
      "enMinuts": "en {{minuts}} min",
      "imminent": "imminent",
      "senseEscalat": "Tothom ha confirmat: no s’escalarà.",
      "tancada": "Activació tancada."
    },
    "ajudaComposer": "Intro per enviar · Maj+Intro per a una línia nova",
    "peuImatge": "Afegeix un peu a la imatge (opcional)…",
    "format": {
      "barra": "Format del text",
      "negreta": "Negreta (Ctrl+B)",
      "cursiva": "Cursiva (Ctrl+I)",
      "ratllat": "Ratllat",
      "llista": "Llista amb pics",
      "llistaNumerada": "Llista numerada",
      "codi": "Codi"
    },
    "imatge": {
      "adjunta": "Adjunta una imatge",
      "treu": "Treu la imatge",
      "tipusNoPermes": "Només es poden adjuntar imatges JPEG, PNG o WebP.",
      "massaGran": "La imatge supera el límit de 10 MB.",
      "alt": "Imatge enviada per {{autor}}",
      "obre": "Obre la imatge",
      "visor": "Imatge del xat",
      "errorCarrega": "No s'ha pogut carregar la imatge",
      "carregant": "Carregant la imatge…",
      "deixaAnar": "Deixa anar la imatge per adjuntar-la"
    },
    "xat": {
      "conversa": "Conversa de l'activació",
      "buit": "Encara no hi ha missatges al xat.",
      "nomesLectura": "L'activació és tancada: el xat és de només lectura."
    },
    "silenci": {
      "silenciar": "Silenciar",
      "reactivar": "Reactivar notificacions",
      "explicacioSilenciar": "Silencia només les notificacions dels missatges del xat d'aquesta activació. Les alertes, confirmacions i escalats es continuen rebent.",
      "explicacioReactivar": "Els missatges del xat d'aquesta activació estan silenciats. Les alertes, confirmacions i escalats es continuen rebent."
    }
  },
  "assistent": {
    "subtitol": "Mateix flux per a Guàrdia i Crisi",
    "pas": "Pas {{n}}",
    "passos": {
      "servei": "Servei",
      "tipus": "Tipus",
      "dades": "Dades",
      "destinataris": "Destinataris",
      "revisio": "Revisió"
    },
    "titols": {
      "servei": "Quin servei està afectat?",
      "tipus": "Tipus d'activació",
      "dades": "Dades de l'activació",
      "destinataris": "Qui s'ha d'avisar?",
      "revisio": "Revisa i envia"
    },
    "serveiText": "Cerca en totes les àrees permeses. Si no trobes el servei, tria el departament (només Guàrdia).",
    "cercaServei": "Cerca un servei, àrea o departament",
    "senseServeis": "Cap resultat.",
    "departamentSencer": "Departament",
    "tipusText": {
      "AVIS": "Comunicació informativa o preventiva.",
      "INCIDENCIA": "Cal actuació del tècnic de guàrdia o del grup."
    },
    "tipusAvis": "Tipus d'avís",
    "tipusAvisDefecte": "Per defecte",
    "marcaCritica": "Crítica",
    "senseCritica": "No tens permís per crear activacions crítiques.",
    "avisCritica": "S'enviarà com a alerta crítica: sona encara que el dispositiu estigui en silenci.",
    "camps": {
      "titol": "Títol",
      "descripcio": "Descripció",
      "proves": "Proves realitzades",
      "inici": "Data i hora d'inici",
      "zona": "Zona",
      "ubicacio": "Ubicació",
      "contacte": "Persona de contacte",
      "risc": "Risc",
      "perills": "Perills identificats",
      "mesures": "Mesures d'actuació",
      "missatge": "Missatge"
    },
    "senseZona": "Sense zona",
    "plantillaText": "Aquest servei té una plantilla de missatge: completa zona, risc, perills i mesures.",
    "opcional": "(opcional en crisi)",
    "persones_one": "{{count}} persona",
    "persones_other": "{{count}} persones",
    "cercaPersona": "Afegeix persones (cerca per nom)",
    "afegeix": "+ {{nom}}",
    "treu": "{{nom}} ✕",
    "canals": "Canals d'enviament",
    "envia": "Envia l'activació",
    "enviaCritica": "Envia l'alerta crítica",
    "enviaIgualment": "Envia igualment",
    "criticaPermis": "Requereix permís d'activació crítica",
    "sensePlantillaText": "Aquest servei no té plantilla: només camps comuns.",
    "esNotificara_one": "Es notificarà a {{count}} persona",
    "esNotificara_other": "Es notificarà a {{count}} persones",
    "continuaRevisio": "Continua a la revisió",
    "pasNom": "{{n}} · {{nom}}"
  },
  "seguiment": {
    "obertes_one": "{{count}} activació oberta",
    "obertes_other": "{{count}} activacions obertes",
    "llista": "Activacions en seguiment",
    "obreDetall": "Obre el detall",
    "lliurats": "Lliurats",
    "llegits": "Llegits",
    "confirmats": "Confirmats",
    "pendents": "Pendents",
    "zones": "Zones afectades",
    "senseZones": "Sense zona indicada.",
    "senseConfirmar": "sense confirmar",
    "totsConfirmats": "tots han confirmat"
  },
  "temps": {
    "min": "fa {{min}} min",
    "hMin": "fa {{h}} h {{min}} min",
    "dies_one": "fa {{count}} dia",
    "dies_other": "fa {{count}} dies"
  },
  "centre": {
    "subtitol": "{{data}} · {{hora}} · s’actualitza en directe",
    "cerca": "Cerca activació, persona o servei",
    "cercaEtiqueta": "Cerca activacions",
    "araMateix": "Ara mateix",
    "kpi": {
      "obertes": "Activacions obertes",
      "critiques_one": "{{count}} crítica",
      "critiques_other": "{{count}} crítiques",
      "crisi_one": "{{count}} crisi",
      "crisi_other": "{{count}} crisis",
      "confirmacions": "Confirmacions rebudes",
      "confirmacionsDetall": "{{confirmats}} de {{total}} persones",
      "cobertura": "Cobertura de guàrdia",
      "buits_one": "{{count}} buit",
      "buits_other": "{{count}} buits",
      "totCobert": "Tot cobert"
    },
    "enCurs": "En curs",
    "perUrgencia": "ordenades per urgència",
    "confirmats": "Confirmats",
    "totsConfirmats": "Tots han confirmat",
    "escalada": "Escalada · nivell {{nivell}}",
    "informatiu": "Informatiu",
    "pendents_one": "{{count}} pendent",
    "pendents_other": "{{count}} pendents",
    "deGuardiaNom": "{{nom}} de guàrdia",
    "atencio": "Necessita la teva atenció",
    "totEnOrdre": "Tot en ordre: no hi ha buits de guàrdia ni sol·licituds pendents.",
    "buit": "Buit",
    "buitText": "{{area}} no té tècnic de guàrdia ara mateix.",
    "assignaGuardia": "Assigna guàrdia",
    "sollicitudsText_one": "{{count}} sol·licitud de canvi de torn espera la teva aprovació.",
    "sollicitudsText_other": "{{count}} sol·licituds de canvi de torn esperen la teva aprovació.",
    "revisa": "Revisa",
    "deGuardia": "De guàrdia ara",
    "calendari": "Calendari",
    "truca": "Truca a {{nom}}",
    "mostraTotes_one": "Mostra l’àrea",
    "mostraTotes_other": "Mostra les {{count}} àrees",
    "mostraMenys": "Mostra’n menys"
  },
  "nova": {
    "subtitol": "Un sol formulari per a Guàrdia i Crisi. Els destinataris es proposen a partir del servei.",
    "blocs": {
      "que": "Què està passant?",
      "qui": "A qui avisem?",
      "revisa": "Revisa i envia"
    },
    "servei": "Servei afectat",
    "canviaServei": "Canvia",
    "tipusText": {
      "AVIS": "Informa; no cal actuar.",
      "INCIDENCIA": "El tècnic de guàrdia ha d’actuar."
    },
    "marcaCritica": "Marca com a crítica: sona encara que el mòbil estigui en silenci",
    "descripcio": "Què veus i què has provat",
    "detalls": "Més detalls (inici, zona, contacte)",
    "detallsPlantilla": "+ Zona, risc i mesures (plantilla del servei)",
    "amagaDetalls": "Amaga els detalls",
    "proposat": "Proposat pel circuit de {{servei}}",
    "triaServeiPrimer": "Tria el servei afectat per veure qui s’avisarà.",
    "afegidaMa": "Afegida a mà",
    "treu": "Treu",
    "afegeixAlgu": "Afegeix algú més",
    "savisaA": "S’avisa a",
    "senseTitol": "Sense títol",
    "falta": {
      "etiqueta": "Falta per completar",
      "servei": "Tria el servei afectat",
      "titol": "Escriu un títol",
      "destinataris": "Activa almenys un grup de destinataris",
      "canals": "Tria almenys un canal"
    },
    "circuitText": "Qui s'avisa i per quin canal ho decideix la configuració del servei i el seu circuit d'escalat: primer el tècnic de guàrdia (de l'àrea o, si no n'hi ha, del departament) i els usuaris a informar; si no respon, trucada, push crític i escalat al següent tècnic i als experts."
  }
}
